<script setup lang="ts">
import { computed, ref } from "vue"
import { storeToRefs } from "pinia"
import { ALLanguageSelector } from "@af-lib/vue-ui"

import { useI18nStore } from "@/stores/i18n"
import { MixpanelInstance } from "@/plugins/mixpanel/mixpanel"
import { useUserStore } from "@/stores/user"

const i18nStore = useI18nStore()

const { currentLocale, languagesList, showLang, isLangLocked } =
  storeToRefs(i18nStore)
const { updateLocale, changeAppLocale } = i18nStore
const { user } = storeToRefs(useUserStore())

const languages = computed(() => languagesList.value)
const selectedLanguage = ref(currentLocale.value)

function onChange() {
  updateAuthLocale(selectedLanguage.value.id)
}

function updateAuthLocale(localeId: number) {
  const selectedLanguage = languagesList.value.find(
    (language) => language.id === localeId
  )

  MixpanelInstance.track("language_updated", {
    language_previous: currentLocale.value?.iso_code,
    language: selectedLanguage?.iso_code,
  })

  // cst_na user cannot update their locale, only change the app language
  if (user.value?.permissions?.includes("cst_na")) {
    changeAppLocale(localeId)
  } else {
    updateLocale(localeId)
  }
}
</script>

<template>
  <ALLanguageSelector
    v-model="selectedLanguage"
    :languages="languages"
    :isDisabled="!showLang || isLangLocked"
    @update:modelValue="onChange"
  />
</template>
